import { render } from "./영상의학과.vue?vue&type=template&id=293b1deb"
import script from "./영상의학과.vue?vue&type=script&lang=js"
export * from "./영상의학과.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__